import "@fontsource/roboto"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"

import React, { useEffect } from "react"
import Lenis from "@studio-freight/lenis"

import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

const WrapWithLenis = ({ element }) => {
  useEffect(() => {
    if (typeof window === "undefined") return

    const lenis = new Lenis({
      duration: 1.2,
      lerp: 0.08,
      smoothWheel: true,
    })

    // LenisのスクロールでScrollTriggerを更新
    lenis.on("scroll", ScrollTrigger.update)

    // GSAPのtickerとLenisを同期
    const update = (time) => {
      lenis.raf(time * 1000)
    }

    gsap.ticker.add(update)
    gsap.ticker.lagSmoothing(0)

    // リサイズ時にScrollTriggerを更新
    ScrollTrigger.refresh()

    return () => {
      gsap.ticker.remove(update)
      lenis.destroy()
    }
  }, [])

  return <>{element}</>
}

export const wrapPageElement = ({ element }) => {
  return <WrapWithLenis element={element} />
}